"use client"
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { useTranslations } from 'use-intl';
import { Inner } from '@/widget/container/ui/Inner';
import { Swiper, SwiperSlide } from 'swiper/react';
import { PC_MAIN } from '@/shared/utils/const';
import { useRecommendStrategy } from '@/features/setting-bot/lib/useRecommendStrategy';
import { useRouter } from 'next/navigation';
//style
import 'swiper/swiper-bundle.css';
import { useSession } from '@/app/providers';


// 메인페이지
export const HomePage = ({
  recommandList,
  profile,
}: {
  recommandList?: PostRecommand_Res_List[];
  profile?: getProfileRes | null;
}) => {
  const session = useSession();
  // FAQ toggle
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const t = useTranslations();

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };


  const faqList = [
    {
      question: t('Main.section5_f1'),
      answer: [
        t('Main.section5_f1_a1'),
        t('Main.section5_f1_a2')
      ],
    },
    {
      question: t('Main.section5_f2'),
      answer: [
        t('Main.section5_f2_a1'),
        t('Main.section5_f2_a2')
      ],
    },
    {
      question: t('Main.section5_f3'),
      answer: [
        t('Main.section5_f3_a1'),
        t('Main.section5_f3_a2')
      ],
    },
    {
      question: t('Main.section5_f4'),
      answer: [
        t('Main.section5_f4_a1'),
      ],
    },
  ];
  const { applyRecommendStrategy } = useRecommendStrategy();
  const router = useRouter();

  const handleStrategySelect = (recom: PostRecommand_Res_List) => {
    if (session?.NewAuthToken) {
      // 전략 적용
      applyRecommendStrategy(recom);

      // 거래 페이지로 이동
      router.push('/v2/trade');
    };
  }

  return (
    <div className="pc-home-page bg-header-nav">
      <section className="first">
        <Inner type="pc" className="flex items-center justify-between py-[60px]">
          <div>
            <h2 className="text-[48px] font-normal text-font-basic leading-[1.19]">
              {t('Main.section1_1')}<br />
              <span
                className="inline-block pt-[16px] pb-[8px] font-black text-[68px] font-black"
                 dangerouslySetInnerHTML={{ __html: t('Main.section1_2')}}
              />
            </h2>
            <div className="first-link">
              <Link href="/v2/trade" className="counseling">{t('Main.section1_3')}</Link>
              {!profile && (
                <a href="/login" className="login">{t('Main.section1_4')}</a>
                // <Link href="/v2/signIn">{t('Main.section1_4')}</Link>
              )}
            </div>
          </div>
          <div className="w-[280px]">
            <Image src={PC_MAIN.firstIcon} width={280} height={560} alt="mobile icon" />
          </div>
        </Inner>
      </section>
      <section className="second">
        <Inner type="pc">
          <div className="pt-[120px] pb-[80px] text-center">
            <h2 className="text-[48px] font-semibold text-[#fff]">{t('Main.section2_1')}</h2>
            <p className="mt-[16px] text-[18px] font-medium tracking-[-0.45px] text-font-gray leading-[1.16]">
              {t('Main.section2_2')}
            </p>
            <p className="mt-[8px] text-[18px] font-medium tracking-[-0.45px] text-font-gray leading-[1.16]">
              {t('Main.section2_3')}
            </p>
            <p className="mt-[8px] text-[18px] font-medium tracking-[-0.45px] text-font-gray leading-[1.16]">
              {t('Main.section2_4')}
            </p>
          </div>
          <div className="w-[1200px] overflow-hidden">
            <Swiper
              spaceBetween={30}
              slidesPerView={3.5}
              className="recommend-wrap"
            >
              {recommandList?.map((recommend) => (
                <SwiperSlide key={recommend.id_rcmd} className="recommend-slide">
                  <div>
                    <div className="flex items-center gap-[16px]">
                      <span className={`flex-shrink-0 position ${recommend.position_side === 'LONG' ? 'long' : 'short'}`}>{recommend.position_side}</span>
                      <p className="text-[28px] font-semibold text-font-white leading-none break-all">{recommend.nm_rcmd}</p>
                    </div>
                    <table className="recommend-slide-table mt-[16px]">
                      <colgroup>
                        <col width="50%" />
                        <col width="50%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <th>추천 종목</th>
                          <td>{recommend.id_tactic + 'USDT'}</td>
                        </tr>
                        <tr>
                          <th>추천 레버리지</th>
                          <td>{recommend.leverage}</td>
                        </tr>
                        <tr>
                          <th>진입 횟수</th>
                          <td>{recommend.tp_setting === "simple" ? recommend.simple_setting.cnt_entry : recommend.detail_setting.length}</td>
                        </tr>
                        <tr>
                          <th>추가 진입 배율</th>
                          <td>{recommend.tp_setting === "simple" ? recommend.simple_setting.rate_extra_entry + '배' : '-'}</td>
                        </tr>
                        <tr>
                          <th>추가 진입 간격</th>
                          <td>{recommend.tp_setting === "simple" ? recommend.simple_setting.gab_extra_entry + '%' : '-'}</td>
                        </tr>
                        <tr>
                          <th>익절</th>
                          <td>{recommend.pct_take_profit}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <button
                    onClick={() => handleStrategySelect(recommend)}
                    className="flex items-center justify-center gap-[24px] mx-auto w-[199px] h-[43px] rounded-[38px] border border-solid border-primary-yellow text-[16px] text-primary-yellow font-semibold tracking-[-0.4px]"
                  >
                    {t('Main.section2_5')}
                    <Image src={PC_MAIN.slideArrow} width={14} height={14} alt="arrow" />
                  </button>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </Inner>
      </section>
      <section className="third">
        <Inner type="pc">
          <div className="pt-[120px] pb-[30px] text-center">
            <h2 className="text-[48px] font-semibold text-[#fff]">{t('Main.section3_1')}</h2>
            <p
              className="mt-[16px] text-[18px] font-medium tracking-[-0.45px] text-font-gray"
              dangerouslySetInnerHTML={{ __html: t('Main.section3_2')}} />
          </div>
          <div className="w-full text-[0]">
            <Image src={PC_MAIN.secondIcon2} width={1200} height={746} alt="pc" unoptimized  />
          </div>
        </Inner>
      </section>
      <section className="fourth py-[80px]">

        <Inner type="pc">
          <h2 className="pt-[30px] pb-[46px] text-[48px] font-semibold text-[#fff] text-center">
            {t('Main.section4_1')}
          </h2>
          <div className="flex items-center gap-[16px]">
            <div className="wrap relative flex-1 w-[calc(100%/3)-16px] max-w-[389px] h-[406px]">
              <div className="upper flex flex-col justify-between h-full py-[50px] px-[30px] pb-[30px] rounded-[8px] border border-solid border-text-white">
                <p className="text-[24px] font-semibold text-font-basic leading-[1.16]">
                  SUPER TRADER 자동매매<br />
                  추천전략 사용으로 수익 실현
                </p>
                <Image src={PC_MAIN.forth1} width={231} height={170} alt="1" />
              </div>
              <div className="bottom absolute top-0 left-0 flex flex-1  flex-col justify-between w-[calc(100%/3)-16px] max-w-[389px] h-full py-[50px] px-[30px] pb-[30px] rounded-[8px] border border-solid border-primary-yellow bg-primary-yellow text-font-black">
                <div>
                  <p className="text-[24px] font-semibold leading-[1.16]">
                    SUPER TRADER 자동매매<br />
                    추천전략 사용으로 수익 실현
                  </p>
                  <p className="text-[18px] tracking-[-0.45px] mt-[30px] leading-[1.15]">
                    다른 프로그램들은 영어로 되어있고 복잡해서 시도조차 못해봤는데, SUPER TRADER는 한글 지원하고 추천설정이란 간단한 설정이 있어서 소액으로 시작해 봤습니다. 자랑할만큼 수익을 본건 아니지만 투입시드에 몇배가 불어나니 잘했다는 생각이 드네요^^                  </p>
                </div>
                <p className="text-[16px] font-semibold">
                  kim*****@gamil.com
                </p>
              </div>
            </div>
            <div className="wrap relative flex-1 w-[calc(100%/3)-16px] max-w-[389px] h-[406px]">
              <div className="upper flex flex-col justify-between h-full py-[50px] px-[30px] pb-[30px] rounded-[8px] border border-solid border-text-white">
                <p className="text-[24px] font-semibold text-font-basic leading-[1.16]">
                  SUPER TRADER 자동매매<br />
                  간편설정 사용으로 수익 실현
                </p>
                <Image src={PC_MAIN.forth2} width={231} height={170} alt="1" />
              </div>
              <div className="bottom absolute top-0 left-0 flex flex-1  flex-col justify-between w-[calc(100%/3)-16px] max-w-[389px] h-full py-[50px] px-[30px] pb-[30px] rounded-[8px] border border-solid border-primary-yellow bg-primary-yellow text-font-black">
                <div>
                  <p className="text-[24px] font-semibold leading-[1.16]">
                    SUPER TRADER 자동매매<br />
                    간편설정으로 수익 실현
                  </p>
                  <p className="clamp-6 text-[18px] tracking-[-0.45px] mt-[30px] leading-[1.15]">
                    처음엔 추천전략을 그대로 사용해 두고 반복실행하여 몇일 잊고 있었는데, 몇일뒤 확인해 보니 잔고가 많이 늘어나 있더라구요..이게 웬일.. 그래서 상승장과 하락장일때 셋팅값을 좀 신경써서 제가 평소 생각했던 매매 타이밍에 진입될수 있게 관리 했더니 수익이 꽤나 만족할 만하게 났습니다. 솔직히 수익이 나면서도 이게 맞나? 싶었네요.. 아무쪼록 조언해주신 매니저님 너무 감사합니다!                  </p>
                </div>
                <p className="text-[16px] font-semibold">
                  Lim*****@gamil.com
                </p>
              </div>
            </div>
            <div className="wrap relative flex-1 w-[calc(100%/3)-16px] max-w-[389px] h-[406px]">
              <div className="upper flex flex-col justify-between h-full py-[50px] px-[30px] pb-[30px] rounded-[8px] border border-solid border-text-white">
                <p className="text-[24px] font-semibold text-font-basic leading-[1.16]">
                  SUPER TRADER 자동매매<br />
                  상세설정 사용으로 수익 실현
                </p>
                <Image src={PC_MAIN.forth3} width={231} height={170} alt="1" />
              </div>
              <div className="bottom absolute top-0 left-0 flex flex-1  flex-col justify-between w-[calc(100%/3)-16px] max-w-[389px] h-full py-[50px] px-[30px] pb-[30px] rounded-[8px] border border-solid border-primary-yellow bg-primary-yellow text-font-black">
                <div>
                  <p className="text-[24px] font-semibold leading-[1.16]">
                    SUPER TRADER 자동매매<br />
                    상세설정으로 수익 실현
                  </p>
                  <p className="text-[18px] tracking-[-0.45px] mt-[30px] leading-[1.15]">
                    양방향 매매를 주로 하는데, 제공하는 기능이 제가 평소 원하던 기능이어서 사용하게 되었습니다. 설정하는 부분도 깔끔하게 되어 있어서 어려움없이 시작했고, 약간의 횡보장에서 확실히 수익히 극대화 되는거 같습니다. 만족하면서 사용하고 있습니다~~</p>
                </div>
                <p className="text-[16px] font-semibold">
                  bin*****@gamil.com
                </p>
              </div>
            </div>
          </div>
        </Inner>
      </section>
      <section className="fifth py-[80px] pb-[50px]">
        <Inner type="pc">
          <div className="py-[80px] text-center">
            <h2 className="text-[48px] font-semibold text-[#fff]"> {t('Main.section5_1')}</h2>
            <p className="mt-[16px] text-[18px] font-medium tracking-[-0.45px] text-font-gray">
              {t('Main.section5_2')}
              <Link href="https://super-trader.gitbook.io/super-trader" target="_blank" className="inline-flex justify-center items-center min-w-[112px] h-[33px] px-[24px] ml-[58px] border border-solid border-primary-yellow text-[14px] text-primary-yellow font-semibold rounded-[24px] leading-none">
                {t('Main.section5_3')}
              </Link>
            </p>
            {faqList.map((faq, idx) => (
              <div
                key={idx}
                className="py-[24px] px-[38px] mt-[30px] bg-[rgba(255,255,255,0.08)] rounded-[8px]"
              >
                <div
                  className="flex items-center justify-between cursor-pointer"
                  onClick={() => toggleFAQ(idx)}
                >
                  <p className="py-[16px] text-[26px] font-semibold text-font-white">
                    {faq.question}
                  </p>
                  <Image
                    src={PC_MAIN.faqArrow}
                    width={24}
                    height={24}
                    alt="arrow"
                    className={`transition-transform duration-250 ${openIndex === idx ? "rotate-180" : ""
                      }`}
                  />
                </div>
                {openIndex === idx && (
                  <div className="p-[24px] mb-[14px] rounded-[8px] bg-[rgba(255,255,255,0.08)] text-left">
                    {faq.answer.map((line, i) => (
                      <p key={i} className="text-[16px] font-medium text-font-gray">
                        {line}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </Inner>
      </section>
    </div>
  )
}